import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AuthService } from './services/auth.service';
import { DataService } from './services/data.service';
import { MediaMatcher } from '@angular/cdk/layout';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit{
  name = 'events';
  public isMobile = true;
  @ViewChild('sidenav') sidenav: MatSidenav;

  mobileQuery: MediaQueryList;
  public dashboardSideNavContent = {
    MY_ACCOUNT: '/account',
    CREATE_EVENT: '/events',
    CREATE_NOTIFICATION: '/create-notification',
    CALENDAR: '/calendar',
    HOME: '/dashboard'
  };
  
  public navLinks = [
    {
      name: 'Home',
      contentLink: this.dashboardSideNavContent.HOME
    },
    {
      name: 'Eventos',
      contentLink: this.dashboardSideNavContent.CREATE_EVENT
    },
    {
      name: 'Calendario',
      contentLink: this.dashboardSideNavContent.CALENDAR
    },
    // {
    //   name: 'Interacciones',
    //   contentLink: this.dashboardSideNavContent.MY_ACCOUNT
    // },
    {
      name: 'Configuración',
      contentLink: this.dashboardSideNavContent.MY_ACCOUNT
    },
    {
      name: 'Soporte y ayuda',
      contentLink: this.dashboardSideNavContent.HOME
    },
  ];

  currentContent = this.dashboardSideNavContent.HOME;

  fillerNav = Array.from({length: 50}, (_, i) => `Nav Item ${i + 1}`);

  private _mobileQueryListener: () => void;

  constructor(public authService: AuthService, 
    public matDialog: MatDialog, 
    changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, 
    public dataService: DataService,
    private deviceService: DeviceDetectorService) { 
    this.isMobile = this.deviceService.isMobile();

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngAfterViewInit(): void {
    // this.sidenavService.setSidenav(this.sidenav);
    this.installPWA();
  }

  private installPWA(): void { 
    let deferredPrompt: any;
    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = e;
      console.log("Intercepting the app install banner prompt");
      try {

        setTimeout(function() {
          deferredPrompt.prompt();
        }, 20000);
    
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
      .then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        deferredPrompt = null;
      });
    }catch(e){
      
    }
    })
  }

  public setDisplay(): any {
    return { 'display': this.dataService.loading ? 'block' : 'none'}
  }

  public loaginDisplay(): any {
    return { 'display': this.authService.isLoggedIn() ? 'block' : 'none'}
  }

  public mainDisplay(): any {
    return {'display': !this.dataService.loading ? 'block' : 'none'}
  } 

  toogleSidenav() {
    this.sidenav.toggle();
   }
 
   ngOnDestroy(): void {
     this.mobileQuery.removeListener(this._mobileQueryListener);
   }
   async ngOnInit() {
    this.dataService.categories =  await this.dataService.getCategories();
   }
  
}
